import { render, staticRenderFns } from "./DataAgreement.vue?vue&type=template&id=bc945ccc&"
import script from "./DataAgreement.vue?vue&type=script&lang=js&"
export * from "./DataAgreement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports